import React from 'react';

import {A} from 'views/AppElements';

import AppUtil from 'AppUtil';
import UserAvatar from 'views/user/UserAvatar';



export const AllStoresPreview = () => {
	const avatar = {id: "allStoreAvatar", storeName: "Stores"};
	const storeLink  = "/stores/all";
	return <div className="storeDiv flexColumn" id="allStoresPreview">
		<A href={storeLink} className="storeAvatar">
			<UserAvatar user={avatar} />
		</A>
		<A href={storeLink} className="storeTitle">View All</A>
	</div>		
}


class StorePreview extends React.Component {
	

	render() {
		let name = null;
		const store = this.props.store;

		if(store)
			name = store.storeName;

		const storeLink = store? AppUtil.getDesignerURL(store): "#";
		return <div className="storeDiv flexColumn">
				<A href={storeLink} className="storeAvatar">
					<UserAvatar user={store} />
				</A>
				<A href={storeLink} className="storeTitle">{name}</A>
			</div>	
	}
}




export default StorePreview;


// WEBPACK FOOTER //
// ./src/views/designer/StorePreview.js